export default __webpack_public_path__ + "static/RUBICON-L-SERIES-26-DISK-SCRUBBER-34f5dc5ac6624ef8e3d3e4b6219f50c9.png";